/* @flow */

import type { ManageInput, ManageClock, InputFunc } from './Common';

export default class InputManager implements ManageInput {
  ch: ManageClock;
  keyboardEventQueue = {};
  keyboardState = {};

  // menu subs
  onMenuKeyPress = {};
  onMenuKeyDown = {};

  // level subs
  onLevelKeyPress = {};
  onLevelKeyDown = {};

  constructor(clockManager: ManageClock) {
    clockManager.subscribeInput(() => this.step());

    window.addEventListener('keydown', event => {
      // event.preventDefault();
      // console.log(event.code);
      this.keyboardEventQueue[event.code] = event;
      this.keyboardState[event.code] = true;
    });
    window.addEventListener('keyup', event => {
      this.keyboardState[event.code] = false;
    });
  }
  cleanup() {
    this.onLevelKeyPress = {};
    this.onLevelKeyDown = {};
  }

  subscribeMenuKeyPress(key: string, newListener: InputFunc) {
    const listeners = this.onMenuKeyPress[key] || [];
    this.onMenuKeyPress[key] = listeners.concat(newListener);
  }
  subscribeMenuKeyDown(key: string, newListener: InputFunc) {
    const listeners = this.onMenuKeyDown[key] || [];
    this.onMenuKeyDown[key] = listeners.concat(newListener);
  }

  subscribeLevelKeyPress(key: string, newListener: InputFunc) {
    const listeners = this.onLevelKeyPress[key] || [];
    this.onLevelKeyPress[key] = listeners.concat(newListener);
  }
  subscribeLevelKeyDown(key: string, newListener: InputFunc) {
    const listeners = this.onLevelKeyDown[key] || [];
    this.onLevelKeyDown[key] = listeners.concat(newListener);
  }

  step() {
    const toProcess = { ...this.keyboardEventQueue };
    this.keyboardEventQueue = {};
    Object.keys(toProcess).forEach(key => {
      if (toProcess[key]) {
        const menuListeners = this.onMenuKeyPress[key] || [];
        menuListeners.forEach(listenerFunc => listenerFunc());
        const levelListeners = this.onLevelKeyPress[key] || [];
        levelListeners.forEach(listenerFunc => listenerFunc());
      }
    });

    const { keyboardState } = this;
    Object.keys(keyboardState).forEach(key => {
      if (keyboardState[key]) {
        const menuListeners = this.onMenuKeyDown[key] || [];
        menuListeners.forEach(listenerFunc => listenerFunc());
        const levelListeners = this.onLevelKeyDown[key] || [];
        levelListeners.forEach(listenerFunc => listenerFunc());
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/InputManager.js